import app from './firebase';
import { useState, useRef } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import "./Stock.css";

const CLIPS = [
  {
    id: "gurkha_001",
    title: "Section commander — map briefing",
    description:
      "A Gurkha section commander analyses enemy positions on a tactical map. Close detail of hands, map markings, and commanding presence. Rare military documentary footage.",
    category: "Military · Documentary",
    duration: "HD · MOV",
    price: 35,
    previewFile: "gurkha_001_preview.mp4",
    hdFile: "gurkha_001_HD.mov",
    tags: ["gurkha", "military", "tactical", "documentary", "nepal"],
  },
  {
    id: "gurkha_002",
    title: "Section — taking cover",
    description:
      "Gurkha soldiers moving into defensive cover positions with precision and discipline. Dynamic action footage suitable for documentary, editorial, and defence industry use.",
    category: "Military · Action",
    duration: "HD · MOV",
    price: 35,
    previewFile: "gurkha_002_preview.mov",
    hdFile: "gurkha_002_HD.mp4",
    tags: ["gurkha", "military", "action", "defence", "soldiers"],
  },
  {
    id: "gurkha_003",
    title: "Section commander — battle orders",
    description:
      "A Gurkha section commander delivers battle orders to his section. Authentic command authority captured in the field. Exceptional for defence, history, and leadership content.",
    category: "Military · Command",
    duration: "HD · MOV",
    price: 35,
    previewFile: "gurkha_003_preview.mp4",
    hdFile: "gurkha_003_HD.mov",
    tags: ["gurkha", "military", "command", "leadership", "nepal"],
  },
];

function ClipCard({ clip }) {
  const [buying, setBuying] = useState(false);
  const [error, setError] = useState(null);
  const videoRef = useRef(null);

  const handleBuy = async () => {
  setBuying(true);
  setError(null);
  try {
    const functions = getFunctions(app, 'us-central1');
    const createCheckout = httpsCallable(functions, "createStockCheckout");
    const result = await createCheckout({
      clipId: clip.id,
      clipTitle: clip.title,
      price: clip.price,
      hdFile: clip.hdFile,
    });
    window.location.href = result.data.url;
  } catch (err) {
    console.error(err);
    setError("Payment could not be started. Please try again.");
    setBuying(false);
  }
};

  return (
    <article className="clip-card">
      <div className="clip-video-wrap">
        <video
          ref={videoRef}
          className="clip-video"
          src={`/previews/${clip.previewFile}`}
          muted
          loop
          playsInline
          onMouseEnter={() => videoRef.current?.play()}
          onMouseLeave={() => {
            videoRef.current?.pause();
            if (videoRef.current) videoRef.current.currentTime = 0;
          }}
        />
        <div className="clip-overlay">
          <span className="play-hint">Hover to preview</span>
        </div>
        <div className="watermark">STIMU STOCK · stimu.app</div>
        <span className="clip-category">{clip.category}</span>
      </div>

      <div className="clip-body">
        <h3 className="clip-title">{clip.title}</h3>
        <p className="clip-desc">{clip.description}</p>
        <div className="clip-tags">
          {clip.tags.map((t) => (
            <span key={t} className="tag">
              {t}
            </span>
          ))}
        </div>
        <div className="clip-footer">
          <div className="clip-meta">
            <span className="clip-format">{clip.duration}</span>
            <span className="clip-licence">Standard licence · commercial use</span>
          </div>
          <div className="clip-price-row">
            <span className="clip-price">£{clip.price}</span>
            <button
              className={`buy-btn ${buying ? "loading" : ""}`}
              onClick={handleBuy}
              disabled={buying}
            >
              {buying ? (
                <span className="spinner" />
              ) : (
                "Buy & download"
              )}
            </button>
          </div>
          {error && <p className="clip-error">{error}</p>}
        </div>
      </div>
    </article>
  );
}

export default function Stock() {
  return (
    <section className="stock-page">
      <header className="stock-header">
        <div className="stock-header-inner">
          <div className="stock-eyebrow">STIMU Stock</div>
          <h1 className="stock-heading">Gurkha footage collection</h1>
          <p className="stock-subhead">
            Rare, authentic military stock footage. Nepali Gurkha soldiers —
            unavailable anywhere else. Instant HD download on purchase.
          </p>
          <div className="stock-badges">
            <span className="badge">HD 1080p</span>
            <span className="badge">Commercial licence</span>
            <span className="badge">Instant download</span>
            <span className="badge badge-charity">50% supports Janmadin.com</span>
          </div>
        </div>
      </header>

      <div className="stock-grid">
        {CLIPS.map((clip) => (
          <ClipCard key={clip.id} clip={clip} />
        ))}
      </div>

      <footer className="stock-footer">
        <p>
          All footage is original STIMU content. By purchasing you agree to our{" "}
          <a href="/licence">standard licence terms</a>. Each purchase supports
          children in Nepal through{" "}
          <a href="https://janmadin.com" target="_blank" rel="noreferrer">
            Janmadin.com
          </a>
          .
        </p>
      </footer>
    </section>
  );
}
